import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { MainLayout } from '../layouts/MainLayout';
import { API } from '../utils/API';
import { useUIContext } from '../context/UIContext';
import { Collector } from '../models/Collector';
import { WelcomeWidget } from '../components/widget/WelcomeWidget';
import { CollectorDataWidget } from '../components/widget/CollectorDataWidget';
import { Separator } from '../components/Separator';
import { CollectorMapWidget } from '../components/widget/CollectorMapWidget';
import { CollectorDiagnosticWidget } from '../components/widget/CollectorDiagnosticWidget';

const renderCollectorInfo = (setCollector: (collector: Collector) => void, collector?: Collector) => {
  if (!collector) return null;
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      gap: 16, 
      marginRight: 40,
      width: '100%'
    }}>
      <div style={{ 
        display: 'flex', 
        flexDirection: 'row', 
        gap: 16,
        flexWrap: 'wrap'
      }}>
        <div style={{ 
          flex: '1 1 300px',
          minWidth: '280px'
        }}>
          <CollectorDataWidget collector={collector} setCollector={setCollector} />
        </div>
        <div style={{ 
          flex: '1 1 300px',
          minWidth: '280px',
          height: '300px'
        }}>
          <CollectorMapWidget collector={collector} />
        </div>
      </div>
      {collector.diagnostics && <CollectorDiagnosticWidget collector={collector} />}
    </div>
  );
};

type RouterParams = {
  id: string;
}

export const CollectorDetails: FC = () => {
  const { id } = useParams<RouterParams>();
  const { loader, toast } = useUIContext();

  const [collector, setCollector] = useState<Collector>();

  const fetchCollectorDetails = async () => {
    if (!id) return;
    loader.showLoader();
    try {
      const response = await API.Users.getCollector(id);
      setCollector(response);
    } catch (error: any) {
      toast.showToast(error.message, 'ERROR');
    } finally {
      loader.hideLoader();
    }
  };

  useEffect(() => {
    if (!id) return;
    fetchCollectorDetails().finally(() => undefined);
  }, [id]);
  return (
    <MainLayout selectedTab="DASHBOARD">
      <WelcomeWidget />
      <Separator size="S" />
      {renderCollectorInfo(setCollector, collector)}
    </MainLayout>
  );
};
